import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  tiposOcorrencia: [],
};

const getters = {
  // Tipos Ocorrencia
  tiposOcorrencia: state => state.tiposOcorrencia.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  tiposOcorrenciaAtivo: state => state.tiposOcorrencia.filter(t => t.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Tipos Ocorrencias
  async fetchTiposOcorrencia({ commit }) {
    const response = await axios.get(`${baseUrl}/tiposocorrencias`);
    if (response.data) {
      commit('setTiposOcorrencia', response.data);
    } else {
      commit('setTiposOcorrencia', []);
    }
  },
  async fetchTiposOcorrenciaSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/tiposocorrencias?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setTiposOcorrencia', response.data);
      } else {
        commit('setTiposOcorrencia', []);
      }
    } catch (error) {
      commit('setTiposOcorrencia', []);
    }
  },
  async addTipoOcorrencia({ commit }, tipoOcorrencia) {
    const response = await axios.post(`${baseUrl}/tiposocorrencias`, tipoOcorrencia, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    tipoOcorrencia.IdTipoOcorrencia = response.data.IdTipoOcorrencia;
    commit('newTipoOcorrencia', tipoOcorrencia);
    return response.data.IdTipoOcorrencia;
  },
  async updateTipoOcorrencia({ commit }, updTipoOcorrencia) {
    await axios.put(`${baseUrl}/tiposocorrencias`, updTipoOcorrencia, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateTipoOcorrencia', updTipoOcorrencia);
  },
  async deleteTipoOcorrencia({ commit }, id) {
    await axios.delete(`${baseUrl}/tiposocorrencias/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeTipoOcorrencia', id);
  },
}

const mutations = {
  // Tipos Ocorrencia
  setTiposOcorrencia: (state, tiposOcorrencia) => state.tiposOcorrencia = tiposOcorrencia,
  newTipoOcorrencia: (state, tipoOcorrencia) => state.tiposOcorrencia.push(tipoOcorrencia),
  removeTipoOcorrencia: (state, id) => state.tiposOcorrencia = state.tiposOcorrencia.filter(tipoOcorrencia => tipoOcorrencia.IdTipoOcorrencia !== id),
  updateTipoOcorrencia: (state, updTipoOcorrencia) => {
    const index = state.tiposOcorrencia.findIndex(tipoOcorrencia => tipoOcorrencia.IdTipoOcorrencia === updTipoOcorrencia.IdTipoOcorrencia);
    if (index !== -1) {
      state.tiposOcorrencia.splice(index, 1, updTipoOcorrencia);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}